module.exports = __webpack_public_path__ + "static/Louis-bester-bf8d52725205d0cbe8e9cead070e4b32.jpg";